export const useNewFormTitleMap = () => {
  return new Map([
    ['1', 'Basic Rider Information (Step 1 of 5)'],
    ['2', 'Safety and Services (Step 2 of 5)'],
    ['3', 'Add Caregiver (Step 3 of 5)'],
    ['4', 'Add Primary Residence Address (Step 4 of 5)'],
    ['5', 'Add School Address (Step 5 of 5)'],
  ]);
};

export const newFormSubmitMap = new Map([
  ['1', 'rider-basic-info'],
  ['2', 'safety-settings'],
  ['3', 'caregiver-form'],
  ['4', 'default-address-form'],
  ['5', 'school-address-form'],
]);

export function removeSavedAttribute(data) {
  if (data.authorizedContactGroups) {
    data.authorizedContactGroups = data.authorizedContactGroups.map((group) => {
      const { saved, ...rest } = group;

      return rest;
    });
  }

  return data;
}

export function generateAnalyticsMustBeMetProtocols(residenceAddress, schoolAddress) {
  return [
    ...(residenceAddress.mustBeMet
      ? [
          {
            assignedMbmProtocol: residenceAddress.mustBeMetProtocol.locationProtocol.replace(/_/g, ' '),
            assignedMbmProtocolLocationType: residenceAddress.residence.address.locationType,
          },
        ]
      : []),
    ...(schoolAddress.mustBeMet
      ? [
          {
            assignedMbmProtocol: schoolAddress.mustBeMetProtocol.locationProtocol.replace(/_/g, ' '),
            assignedMbmProtocolLocationType: schoolAddress.school.address.locationType,
          },
        ]
      : []),
  ];
}
